export default class CDSFilter {

    static filterLibrary(library, publications) {
        library.catalogList = CDSFilter.filterCatalogList(library.catalogList, publications);
    }

    static filterCatalogList(catalogList, publications) {
        return catalogList.filter((elem, i, array) => {
            let publication = publications[elem.catalogId];
            if (publication) {
                if (!publication.recursive){
                    elem.childList = CDSFilter.filterCatalogList(elem.childList, publications);
                }
                return true;
            }
            return false;
        });
    }

}
